import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface UpgradeModalProps {
  open: boolean;
  onClose: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle sx={{ pt: 4, textAlign: "center" }}>
      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: 2.5,
          display: "grid",
          placeItems: "center",
          bgcolor: "rgba(139, 92, 246, 0.14)",
          color: "primary.light",
          mx: "auto",
          mb: 2,
        }}
      >
        <LockOutlinedIcon />
      </Box>
      {t("dashboard.upgrade.title")}
    </DialogTitle>
    <DialogContent>
      <Typography color="text.secondary" textAlign="center">
        {t("dashboard.upgrade.body")}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Button fullWidth variant="contained" onClick={onClose}>
        {t("dashboard.upgrade.confirm")}
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default UpgradeModal;
